import { join } from "node:path";
import { requireResolve } from "./requireResolve.js";
const getNextJSVersion = async () => {
  const { readFile } = await import("node:fs/promises");
  const packageJSONPath = requireResolve("next/package.json", join(process.cwd(), "package.json"));
  const { version } = JSON.parse(await readFile(packageJSONPath, "utf8"));
  return version;
};
export {
  getNextJSVersion
};
//# sourceMappingURL=getNextJSVersion.js.map
